import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListCustomerStore({
  loading,
  customerStores,
  selected,
  setSelected,
  handleToggleStatus,
  pageCount,
  handlePageClick,
}) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered mb-0">
        <thead className="table-light">
          <tr>
            <th>Select</th>
            <th>Customer</th>
            <th>Customer Store Name</th>
            <th>GSTN</th>
            <th>Address</th>
            <th>Landmark</th>
            <th>Country</th>
            <th>State</th>
            <th>District</th>
            <th>Zip</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="11" className="text-center py-4">
                <Loading />
              </td>
            </tr>
          ) : customerStores.length > 0 ? (
            customerStores.map((store) => {
              const isInactive = store.status !== "Active";

              return (
                <tr key={store.id} className={isInactive ? "table-secondary" : ""}>
                  <td>
                    <input
                      type="radio"
                      name="customerStoreSelect"
                      checked={selected?.id === store.id}
                      onChange={() => setSelected(store)}
                      disabled={isInactive}
                    />
                  </td>
                  <td>{store.customerName}</td>
                  <td>{store.customerStoreName}</td>
                  <td>{store.GSTN}</td>
                  <td>{store.address}</td>
                  <td>{store.landMark}</td>
                  <td>{store.countryName}</td>
                  <td>{store.stateName}</td>
                  <td>{store.cityName}</td>
                  <td>{store.zip}</td>
                  <td>
                    <span
                      className={`badge ${store.status === "Active" ? "bg-success" : "bg-secondary"}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleToggleStatus(store.id)}
                    >
                      {store.status}
                    </span>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="11" className="text-center py-3">
                No customer stores found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="< Previous"
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
      />
    </div>
  );
}
